"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Maximize2, BookOpen } from "lucide-react";
export default function GirmitiyaProudSection(t0) {
  const $ = _c(54);
  const {
    section,
    isEven,
    onOpenLightbox
  } = t0;
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const {
    id,
    title,
    content,
    subsections,
    images: t1
  } = section;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const images = t2;
  const t3 = String(id);
  let t4;
  if ($[2] !== t3) {
    t4 = t3.padStart(2, "0");
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const formattedId = t4;
  const hasImages = images.length > 0;
  const isMultiImage = images.length > 1;
  let t5;
  if ($[4] !== images.length) {
    t5 = () => {
      setActiveImageIndex(prev => (prev + 1) % images.length);
    };
    $[4] = images.length;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleNext = t5;
  let t6;
  if ($[6] !== images.length) {
    t6 = () => {
      setActiveImageIndex(prev_0 => (prev_0 - 1 + images.length) % images.length);
    };
    $[6] = images.length;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handlePrev = t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e => {
      touchStartX.current = e.targetTouches[0].clientX;
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleTouchStart = t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e_0 => {
      touchEndX.current = e_0.targetTouches[0].clientX;
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const handleTouchMove = t8;
  let t9;
  if ($[10] !== handleNext || $[11] !== handlePrev || $[12] !== isMultiImage) {
    t9 = () => {
      if (!touchStartX.current || !touchEndX.current) {
        return;
      }
      const distance = touchStartX.current - touchEndX.current;
      const isLeftSwipe = distance > 40;
      const isRightSwipe = distance < -40;
      if (isLeftSwipe && isMultiImage) {
        handleNext();
      } else {
        if (isRightSwipe && isMultiImage) {
          handlePrev();
        }
      }
      touchStartX.current = null;
      touchEndX.current = null;
    };
    $[10] = handleNext;
    $[11] = handlePrev;
    $[12] = isMultiImage;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const handleTouchEnd = t9;
  const t10 = `section-${id}`;
  const t11 = `py-10 sm:py-16 md:py-20 border-b border-[#0F1C2E]/10 transition-colors duration-300 ${isEven ? "bg-[#F4EFE6]" : "bg-[#EAE4D8]/60"}`;
  let t12;
  if ($[14] !== formattedId) {
    t12 = <div className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-[#0F1C2E] text-[#C9A84C] font-display font-semibold text-[14px] sm:text-[16px] shadow-sm">{formattedId}</div>;
    $[14] = formattedId;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="h-px w-8 sm:w-12 bg-[#DF6D2A]" />;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== formattedId) {
    t14 = <span className="font-body text-[10.5px] sm:text-[12px] uppercase tracking-[0.18em] font-medium text-[#DF6D2A]">Chapter {formattedId} of 60</span>;
    $[17] = formattedId;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t12 || $[20] !== t14) {
    t15 = <div className="flex items-center gap-2.5 mb-4 sm:mb-6">{t12}{t13}{t14}</div>;
    $[19] = t12;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const t16 = `lg:col-span-6 xl:col-span-6 flex flex-col justify-start ${isEven ? "lg:order-2" : "lg:order-1"}`;
  let t17;
  if ($[22] !== title) {
    t17 = <h2 className="font-display text-[24px] sm:text-[32px] md:text-[40px] font-light leading-[1.15] text-[#0F1C2E] mb-4 sm:mb-6 tracking-tight">{title}</h2>;
    $[22] = title;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== content || $[25] !== subsections) {
    t18 = subsections && subsections.length > 0 ? <div className="flex flex-col gap-4 sm:gap-6">{subsections.map(_temp2)}</div> : <div className="flex flex-col gap-3 sm:gap-4 font-body text-[14px] sm:text-[16px] leading-[1.75] text-[#4C596B]">{content ? content.split("\n\n").map(_temp3) : null}</div>;
    $[24] = content;
    $[25] = subsections;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t16 || $[28] !== t17 || $[29] !== t18) {
    t19 = <div className={t16}>{t17}{t18}</div>;
    $[27] = t16;
    $[28] = t17;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  const t20 = `lg:col-span-6 xl:col-span-6 ${isEven ? "lg:order-1" : "lg:order-2"}`;
  let t21;
  if ($[31] !== activeImageIndex || $[32] !== handleNext || $[33] !== handlePrev || $[34] !== handleTouchEnd || $[35] !== hasImages || $[36] !== images || $[37] !== isMultiImage || $[38] !== onOpenLightbox || $[39] !== title) {
    t21 = !hasImages ? <div className="relative w-full h-[260px] sm:h-[360px] md:h-[400px] rounded-2xl bg-[#0F1C2E] border border-white/10 p-6 sm:p-8 flex flex-col items-center justify-center text-center shadow-xl overflow-hidden group"><div className="absolute inset-0 bg-gradient-to-br from-[#0F1C2E] via-[#0F1C2E]/90 to-[#DF6D2A]/10 opacity-60" /><div className="relative z-10 flex flex-col items-center max-w-[300px]"><div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#DF6D2A]/15 border border-[#DF6D2A]/30 flex items-center justify-center text-[#DF6D2A] mb-3 sm:mb-4"><BookOpen size={24} className="sm:w-7 sm:h-7" /></div><span className="font-body text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-[#C9A84C] mb-1.5 font-medium">Archival Record</span><h4 className="font-display text-[18px] sm:text-[22px] text-[#F4EFE6] font-medium mb-1.5">{title}</h4><p className="font-body text-[12px] sm:text-[13px] text-[#F4EFE6]/60 leading-relaxed">Historical document record preserved in text. Visual archive images coming soon.</p></div></div> : isMultiImage ? <div className="relative flex flex-col gap-2.5"><div onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} className="relative w-full h-[260px] sm:h-[360px] md:h-[420px] rounded-2xl bg-[#0F1C2E] overflow-hidden shadow-xl border border-[#0F1C2E]/10 group touch-pan-y select-none"><AnimatePresence mode="wait"><motion.div key={activeImageIndex} initial={{
            opacity: 0,
            scale: 0.98
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.98
          }} transition={{
            duration: 0.25
          }} className="w-full h-full relative cursor-pointer" onClick={() => onOpenLightbox(images, activeImageIndex, title)}><img src={encodeURI(images[activeImageIndex])} alt={`${title} - Image ${activeImageIndex + 1}`} className="w-full h-full object-contain p-1.5 sm:p-2 bg-[#0F1C2E] transition-transform duration-500 group-hover:scale-[1.02]" loading="lazy" /><div className="absolute inset-0 bg-gradient-to-t from-[#0F1C2E]/80 via-transparent to-transparent opacity-90 sm:opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-between p-3 sm:p-4 pointer-events-none"><span className="font-body text-[11px] sm:text-[12px] text-[#F4EFE6] font-light flex items-center gap-1.5 bg-[#0F1C2E]/85 px-2.5 py-1 sm:px-3 sm:py-1.5 rounded-full backdrop-blur-md border border-white/10"><Maximize2 size={12} className="text-[#DF6D2A]" />Tap to enlarge</span></div></motion.div></AnimatePresence><button onClick={handlePrev} aria-label="Previous image" className="absolute left-2 sm:left-3 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#0F1C2E]/85 hover:bg-[#DF6D2A] text-white flex items-center justify-center border border-white/20 shadow-lg z-10 transition-transform active:scale-95"><ChevronLeft size={18} className="sm:w-5 sm:h-5" /></button><button onClick={handleNext} aria-label="Next image" className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#0F1C2E]/85 hover:bg-[#DF6D2A] text-white flex items-center justify-center border border-white/20 shadow-lg z-10 transition-transform active:scale-95"><ChevronRight size={18} className="sm:w-5 sm:h-5" /></button><div className="absolute top-2.5 right-2.5 sm:top-3 sm:right-3 z-10 px-2.5 py-0.5 sm:px-3 sm:py-1 rounded-full bg-[#0F1C2E]/85 border border-white/20 text-[#F4EFE6] font-mono text-[10px] sm:text-[11px] font-medium backdrop-blur-md">{activeImageIndex + 1} / {images.length}</div></div><div className="flex items-center gap-2 overflow-x-auto pb-1 pt-0.5 scrollbar-none">{images.map((img, idx_1) => <button key={idx_1} onClick={() => setActiveImageIndex(idx_1)} className={`relative h-12 w-16 sm:h-14 sm:w-20 rounded-lg overflow-hidden flex-shrink-0 border-2 transition-all ${idx_1 === activeImageIndex ? "border-[#DF6D2A] ring-2 ring-[#DF6D2A]/30 scale-105" : "border-transparent opacity-50 hover:opacity-100"}`}><img src={encodeURI(img)} alt="" className="w-full h-full object-cover" loading="lazy" /></button>)}</div></div> : <div onClick={() => onOpenLightbox(images, 0, title)} className="relative w-full h-[260px] sm:h-[360px] md:h-[420px] rounded-2xl bg-[#0F1C2E] overflow-hidden shadow-xl border border-[#0F1C2E]/10 cursor-pointer group select-none"><img src={encodeURI(images[0])} alt={title} className="w-full h-full object-contain p-1.5 sm:p-2 bg-[#0F1C2E] transition-transform duration-500 group-hover:scale-[1.02]" loading="lazy" /><div className="absolute inset-0 bg-gradient-to-t from-[#0F1C2E]/80 via-transparent to-transparent opacity-90 sm:opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-between p-3 sm:p-4"><span className="font-body text-[11px] sm:text-[12px] text-[#F4EFE6] font-light flex items-center gap-1.5 bg-[#0F1C2E]/85 px-2.5 py-1 sm:px-3 sm:py-1.5 rounded-full backdrop-blur-md border border-white/10"><Maximize2 size={12} className="text-[#DF6D2A]" />Tap to enlarge</span></div></div>;
    $[31] = activeImageIndex;
    $[32] = handleNext;
    $[33] = handlePrev;
    $[34] = handleTouchEnd;
    $[35] = hasImages;
    $[36] = images;
    $[37] = isMultiImage;
    $[38] = onOpenLightbox;
    $[39] = title;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== t20 || $[42] !== t21) {
    t22 = <div className={t20}>{t21}</div>;
    $[41] = t20;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t19 || $[45] !== t22) {
    t23 = <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-start">{t19}{t22}</div>;
    $[44] = t19;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t15 || $[48] !== t23) {
    t24 = <div className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8">{t15}{t23}</div>;
    $[47] = t15;
    $[48] = t23;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t10 || $[51] !== t11 || $[52] !== t24) {
    t25 = <section id={t10} className={t11}>{t24}</section>;
    $[50] = t10;
    $[51] = t11;
    $[52] = t24;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  return t25;
}
function _temp3(para_0, idx_0) {
  return <p key={idx_0} className="leading-relaxed">{para_0}</p>;
}
function _temp2(sub, idx) {
  return <div key={idx} className="bg-white/70 p-4 sm:p-6 rounded-xl border border-[#0F1C2E]/10 shadow-sm"><div className="flex items-start gap-2 mb-2.5"><span className="w-2 h-2 rounded-full bg-[#DF6D2A] mt-2 flex-shrink-0" /><h3 className="font-display text-[18px] sm:text-[22px] font-semibold text-[#0F1C2E] leading-snug">{sub.heading}</h3></div>{sub.content.split("\n\n").map(_temp)}</div>;
}
function _temp(para, pIdx) {
  return <p key={pIdx} className="font-body text-[14px] sm:text-[15.5px] leading-[1.7] text-[#4C596B] mb-2.5 last:mb-0">{para}</p>;
}